<script setup lang="ts">
import HeaderTitleAndDrivingDetail from "@/components/Every24HoursReportPreviewParts/HeaderTitleAndDrivingDetail.vue";
import ChartDetail from "@/components/Every24HoursReportPreviewParts/ChartDetail.vue";
import every24HoursPreviewType from "@/types/responses/every24HoursPreview";
import { computed } from "vue";

const emit = defineEmits(['update:modelValue']);

const props = defineProps<{
  modelValue: string
  index: number
  deliveryPlan: every24HoursPreviewType
  downloading: boolean
  chartDetails:{
    deliveryPlanDate: string,
    displayStartTime: string,
    drivingDistance: string,
    drivingTime: string
  }
}>()

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
})
</script>
<template>
  <div class="w-100">
    <HeaderTitleAndDrivingDetail
      :deliveryPlan="props.deliveryPlan"
      :index="props.index"
    />
    <ChartDetail
      v-model="modelValue"
      :index="props.index"
      :deliveryPlan="props.deliveryPlan"
      :downloading="props.downloading"
      :chartDetails="props.chartDetails"
    />
  </div>
</template>
